import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { ActionIcon, Divider, Flex, Text, useMantineTheme } from '@mantine/core';
import { useClickOutside } from '@mantine/hooks';
import { memo } from 'react';
import styled from 'styled-components';

interface Props {
	className?: string;
	instruction: string | null;
	title: string;
	onNext: () => void;
	onPrev: () => void;
	onClose: () => void;
	disableNext: boolean;
	disablePrev: boolean;
}

const InstructionsCardModal = ({
	disableNext,
	disablePrev,
	instruction,
	onClose,
	title,
	onNext,
	onPrev,
	className,
}: Props) => {
	const tInvestor = useTranslationInvestor();
	const ref = useClickOutside(onClose);
	const mantineTheme = useMantineTheme();

	return (
		<div className={className} ref={ref}>
			<Flex justify="space-between" align="center">
				<Flex direction="column" gap="0.25rem">
					<Text fw={600}>{tInvestor('investment.join.kyc.instruction_for')}</Text>
					<Text>{title}</Text>
				</Flex>
				<Flex gap="0.5rem">
					<ActionIcon disabled={disableNext} onClick={onNext}>
						<Icon
							variant="caret-down"
							size="lg"
							color={disableNext ? undefined : mantineTheme.colors.black[0]}
						/>
					</ActionIcon>
					<ActionIcon disabled={disablePrev} onClick={onPrev}>
						<Icon
							variant="caret-up"
							size="lg"
							color={disablePrev ? undefined : mantineTheme.colors.black[0]}
						/>
					</ActionIcon>
				</Flex>
			</Flex>
			<Divider />
			<Text>{instruction}</Text>
		</div>
	);
};

const Memoized = memo(InstructionsCardModal);
const Styled = styled(Memoized)`
	width: 50rem;

	display: flex;
	flex-direction: column;
	gap: 1rem;
	padding: 1rem;
	border: 1px solid ${(props) => props.theme.v3.colors.gray[4]};
	background-color: ${(props) => props.theme.v3.colors.white[0]};
	border-radius: 4px 4px 0 0;
	box-shadow: 0 4px 8px 0 #b8bfc2;
`;

export { Styled as InstructionsCardModal };
